/** Prepend `https://` if the URL has no protocol, so the browser won't treat it as a relative path. */
export function ensureProtocol(url: string): string {
  return /^https?:\/\//.test(url) ? url : `https://${url}`;
}
